<template>
    <div class="container">
        <div class="row">
            <div class="twelve columns"><h1>Login</h1></div>
        </div>
        <div class="row">
            <div class="six columns"><label>Kind of Credential</label></div>
            <div class="six columns">
                <select v-model="myKindofCredential">
                    <option disabled value="">Please select one</option>
                    <option value="password">Account / Password</option>
                    <option value="fido2">FIDO-2 authenticator</option>
                </select>
            </div>
        </div>
        <div v-if="myKindofCredential!==''" class="row">
            <div class="six columns"><label>Account</label></div>
            <div class="six columns"><input type="text" v-model="myAccount"></div>
        </div>
        <div v-if="myKindofCredential==='password'" class="row">
            <div class="six columns"><label>Password</label></div>
            <div class="six columns"><input type="password" v-model="myPasswd" autocomplete="false"></div>
        </div>
        <div v-if="myKindofCredential!==''" class="row">
            <div class="six columns">&nbsp; </div>
            <div class="six columns"><button @click="runLogin" class="button button-primary">Login</button></div>
        </div>

        <div class="row">
            <div class="six columns">&nbsp; </div>
            <div class="six columns" style="line-height:42px;"><a href="#/Register">Register</a></div>
        </div>
    </div>
</template>

<script>
import { checkUserLogin } from '../services/helper-fido2.js'
export default {
    name: 'PageLogin',
    data: function () {
        return {
            myKindofCredential: '',
            myAccount: '',
            myPasswd: ''
        }
    },
    methods: {
        canLogin: function () {
            console.log(`PageLogin.canLogin`)
            return (
                this.myKindofCredential !== '' &&
                this.myAccount.length > 0 &&
                (this.myKindofCredential === 'fido2' || this.myPasswd.lentth > 0)
            )
        },
        runLogin: function () {
            if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
                let userDetails = {
                    kindof: this.myKindofCredential,
                    user: this.myAccount
                }
                if (this.myKindofCredential === 'password') {
                    userDetails.password = this.myPasswd
                }

                if (this.myKindofCredential === 'fido2') {
                    checkUserLogin(userDetails)
                        .then(resp => {
                            if (resp) {
                                console.log(`PageLogin.runLogin: resp: `, resp)
                                // return resp.json()
                                // return resp ? resp.body : undefined
                                userDetails.UserId = resp.UserId
                                userDetails.DisplayName = resp.DisplayName
                                // $$$ TODO: Cryptographical Access-Token needed here !!
                                //
                                // + store logged in user (user, displayName, userId)
                                // + redirect to home-page
                                this.$parent.$emit('user_loggedin', JSON.parse(JSON.stringify(userDetails)))
                            } else {
                                // $$$
                                alert('Login Failed!')
                            }
                        })
                        .catch(err => {
                            console.error(`PageLogin.runLogin: err: `, err)
                        })
                } else {
                    // $$$ TODO: IMPLEMENT ME !!
                }
            }
        }
    }
}
</script>

<style scope>
    input { color: #333333; width: 100%; }
    select { color: #333333; }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageLogin.vue